<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  mounted() {
    function checkIE() {
      return (
        "-ms-scroll-limit" in document.documentElement.style &&
        "-ms-ime-align" in document.documentElement.style
      );
    }
    if (checkIE()) {
      window.addEventListener(
        "hashchange",
        () => {
          const currentPath = window.location.hash.slice(1);
          if (this.$route.path !== currentPath) {
            this.$router.push(currentPath);
          }
        },
        false
      );
    }
  },
};
</script>
<style lang="scss">
html,
body,
#app {
  width: 100%;
  height: 100%;
  margin: 0;
  padding: 0;
  font-family: "Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB",
    "Microsoft YaHei", "微软雅黑", Arial, sans-serif;
  text-shadow: 1px 1px rgb(96 98 102 / 10%);
}

* {
  box-sizing: border-box;
}

#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}

//#nav {
//  padding: 30px;
//}

#nav a {
  font-weight: bold;
  color: #2c3e50;
}

#nav a.router-link-exact-active {
  color: #42b983;
}

.icon {
  width: 1em;
  height: 1em;
  vertical-align: -0.15em;
  fill: currentColor;
  overflow: hidden;
}

::-webkit-scrollbar {
  width: 6px;
  height: 6px;
}

/*定义滚动条轨道 内阴影+圆角*/
::-webkit-scrollbar-track {
  border-radius: 10px;
  cursor: pointer;
}

/*定义滑块 内阴影+圆角*/
::-webkit-scrollbar-thumb {
  border-radius: 10px;
  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
  background-color: rgba(144, 147, 153, 0.5);
}

.uploadDialog {
  .el-dialog__body {
    height: 100% !important;

    .upload-demo {
      text-align: left;
      overflow: auto;
      width: 490px;
      margin: 0 auto;
    }
  }
}

.imgDialog {
  .el-dialog__header {
    border-bottom: 0 !important;
  }

  .el-dialog__body {
    height: 508px;
    display: flex;

    img {
      max-width: 100%;
      max-height: 100%;
      object-fit: contain;
    }
  }
}

.writeoff_unlock_dialog {
  .el-dialog__header {
    text-align: left;
    border-bottom: 1px solid #d8d8d8;
  }

  .el-dialog__body {
    .el-form {
      display: table;
      margin: 0 auto;

      .el-date-editor.el-input {
        width: 215px;
      }
    }
  }
}

.popoverTip {
  width: 18px;
  height: 18px;
  line-height: 15px !important;
  border: 1px solid #1f8eeb;
  color: #1f8eeb !important;
  background: #fff !important;
  overflow: hidden;
  *zoom: 1;
  display: inline-block !important;
  *display: inline;
  zoom: 1;
  vertical-align: sub;
  cursor: pointer;
  text-align: center;
  font-size: 15px !important;
  font-weight: bold;
  margin-left: 7px !important;

  &:hover {
    color: #fff !important;
    background: #1f8eeb !important;
  }
}

.el-picker-panel__shortcut {
  color: #606266;
  font-family: "Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB",
    "Microsoft YaHei", "微软雅黑", Arial, sans-serif;
  text-shadow: 1px 1px rgb(96 98 102 / 10%);
}</style>
